import React from 'react';
import { NavLink } from 'react-router-dom';

class UseCases extends React.Component {
	render() {
		return (
			<div className="fullwidth dark">
				<div className="row">
					<div className="twelve columns text-center">
						<h2>When Do You Need Confidential Servers?</h2>
						<p style={{fontSize: '1.1em', marginBottom: '40px'}}>Hardware-enforced encryption isn't just for compliance - it's for anyone who can't afford data breaches</p>
					</div>
				</div>
				<div className="row">
					<div className="six columns">
						<div className="panel bordered">
							<h3>You Handle Sensitive Data</h3>
							<hr className="grey" />
							<p><strong>Customer databases, financial records, medical information, or intellectual property</strong> - if a breach would be catastrophic, standard encryption isn't enough. Confidential servers ensure that even if someone gains physical access to the hardware or root access to the host, your data remains encrypted and inaccessible.</p>
							<p><strong>Real scenario:</strong> A hosting provider employee with malicious intent, a compromised hypervisor, or even a government subpoena can't access your data because the CPU itself enforces encryption - not just software.</p>
						</div>
					</div>
					<div className="six columns">
						<div className="panel bordered">
							<h3>You Can't Trust the Host</h3>
							<hr className="grey" />
							<p><strong>Zero-trust architecture</strong> means you don't have to trust your hosting provider, the hypervisor, or other tenants on the same hardware. With AMD SEV, the processor itself guarantees isolation - it's mathematically impossible for anyone else to access your encrypted memory or disk.</p>
							<p><strong>Perfect for:</strong> Multi-tenant SaaS platforms, cryptocurrency exchanges, blockchain nodes, or any business where "trust but verify" isn't enough - you need "verify, don't trust."</p>
						</div>
					</div>
				</div>
				<div className="row" style={{marginTop: '20px'}}>
					<div className="six columns">
						<div className="panel bordered">
							<h3>Compliance Requires Hardware Encryption</h3>
							<hr className="grey" />
							<p><strong>GDPR, HIPAA, PCI-DSS, and other regulations</strong> increasingly require hardware-level encryption, not just software-based solutions. Confidential servers provide the cryptographic isolation needed for compliance audits and regulatory requirements.</p>
							<p><strong>Why it matters:</strong> Software encryption can be bypassed. Hardware encryption enforced by the CPU cannot - making it the gold standard for compliance-sensitive workloads in healthcare, finance, and government sectors.</p>
						</div>
					</div>
					<div className="six columns">
						<div className="panel bordered">
							<h3>You Need VPS Flexibility with Dedicated Security</h3>
							<hr className="grey" />
							<p><strong>Traditional dedicated servers</strong> offer security but lack flexibility. Standard VPS offers flexibility but no real security. Confidential servers give you both: instant provisioning, on-demand scaling, and hardware-enforced encryption that dedicated servers can't match without complex manual setup.</p>
							<p><strong>Best of both worlds:</strong> Deploy in 60 seconds like a VPS, scale resources instantly, but with the security guarantees of a dedicated server.</p>
						</div>
					</div>
				</div>
				<div className="row" style={{marginTop: '40px'}}>
					<div className="twelve columns text-center">
						<div className="panel" style={{backgroundColor: '#f5f5f5', border: 'none', padding: '30px'}}>
							<h3 style={{color: '#d74937', marginTop: '0'}}>Still Not Sure?</h3>
							<p style={{fontSize: '1.1em'}}>If you're asking "Do I need this?" the answer is probably yes if: you handle sensitive data, compliance matters, you can't afford a breach, or you need to prove to auditors that your data is truly protected. <strong>When in doubt, choose confidentiality.</strong></p>
							<p><NavLink to="/en/contact-us" className="button radius large">Talk to Our Team</NavLink></p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default UseCases;
